module.exports = __webpack_public_path__ + "static/media/Sachin.b8bf2f54.png";